import { LoggerParamMetadata, PROPERTY_KEY_LOG_VALUES } from "./paramMetadata";
import { ProjectorFn } from "./projectorFn";

/**
 * Allows the customization of how this argument is displayed in context that is logged.
 * Useful for avoiding logging sensitive data to the console.
 */

export function ProjectAs<T>(project: ProjectorFn<T>): ParameterDecorator
{
    return propertyDescriptor as ParameterDecorator;

    function propertyDescriptor(target: object, methodName: string | symbol, index: number): void
    {
        const _methodName = methodName || "ctor";
        const existingLogValues: Array<LoggerParamMetadata> = Reflect.getOwnMetadata(PROPERTY_KEY_LOG_VALUES, target, _methodName) || [];

        const metadata = existingLogValues[index] || (existingLogValues[index] = {});
        metadata.project = project;

        Reflect.defineMetadata(PROPERTY_KEY_LOG_VALUES, existingLogValues, target, _methodName);
    }
}
